var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppSnack',{ref:"snack",attrs:{"options":_vm.alertOptions,"show":_vm.showSnack}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }